import { createApiClient } from "@akhshy/client";

const baseUrl = import.meta.env.VITE_API_URL ?? "http://localhost:8787";

/** Shared, public (unauthenticated) API client for the website. */
export const client = createApiClient({ baseUrl });
